// extracted by mini-css-extract-plugin
export default {"loginHead":"login_loginHead__dYf2x","error":"login_error__wq+fc"};